export const UPDATE_USER = "UPDATE_USER";
export const SUBMIT_USER = "SUBMIT_USER";
export const REQUEST_USER = "REQUEST_USER";
export const RECIEVE_USER = "RECIEVE_USER";
export const LOGOUT_USER = "LOGOUT_USER";
